import clsx from 'clsx'
import type { Sport } from '@/hooks/useSport'
import { useTenant } from '@/contexts/TenantContext'
import { getSportLabel } from '@/lib/tenant'

interface SportToggleProps {
  sport: Sport
  onToggle: () => void
}

export function SportToggle({ sport, onToggle }: SportToggleProps) {
  const tenant = useTenant()
  const menLabel = getSportLabel(tenant.sportCategory, 'men')
  const womenLabel = getSportLabel(tenant.sportCategory, 'women')

  return (
    <button
      onClick={onToggle}
      className="relative grid grid-cols-2 items-center bg-pitch-800 rounded-full p-0.5 w-max h-9"
      aria-label={`Switch to ${sport === 'men' ? womenLabel : menLabel}`}
    >
      <div
        className={clsx(
          'absolute top-0.5 bottom-0.5 w-[calc(50%-2px)] rounded-full bg-accent transition-transform duration-300 ease-out',
          sport === 'women' && 'translate-x-[calc(100%+4px)]',
        )}
      />
      <span className={clsx(
        'relative z-10 px-4 whitespace-nowrap text-center text-sm font-semibold transition-colors duration-200',
        sport === 'men' ? 'text-white' : 'text-slate-400',
      )}>
        {menLabel}
      </span>
      <span className={clsx(
        'relative z-10 px-4 whitespace-nowrap text-center text-sm font-semibold transition-colors duration-200',
        sport === 'women' ? 'text-white' : 'text-slate-400',
      )}>
        {womenLabel}
      </span>
    </button>
  )
}
